import { render, staticRenderFns } from "./Ordercai.vue?vue&type=template&id=1ab70b1a&scoped=true"
import script from "./Ordercai.vue?vue&type=script&lang=js"
export * from "./Ordercai.vue?vue&type=script&lang=js"
import style0 from "./Ordercai.vue?vue&type=style&index=0&id=1ab70b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab70b1a",
  null
  
)

export default component.exports